import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { DentalService } from '../../_service/dental.service';
import {ScanBookListResponse,BookedScanList,UserList,UserResponse,CircleList,CircleResponse } from 'src/app/_model/dental.model';
import {PageEvent,MatPaginator} from '@angular/material/paginator';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ScanUpdateModalComponent } from '../../scanbook/scan-update-modal/scan-update-modal.component';
import { ScanPaymentModalComponent } from '../../scanbook/scan-payment-modal/scan-payment-modal.component';
declare var $: any;
import * as XLSX from 'xlsx';
import {formatDate} from '@angular/common';
import { SpokRemarksComponent } from '../spok-remarks/spok-remarks.component';
import { AccountsRemarksComponent } from '../accounts-remarks/accounts-remarks.component';
import { ScanProAssignmentComponent } from '../scan-pro-assignment/scan-pro-assignment.component';
import { ScanBookCaseHistoryComponent } from '../scan-book-case-history/scan-book-case-history.component';
@Component({
  selector: 'app-scan-book-list',
  templateUrl: './scan-book-list.component.html',
  styleUrls: ['./scan-book-list.component.css']
})
export class ScanBookListComponent implements OnInit {
  perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;
  pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;userId:string;sc3Url:string;
  scanList:BookedScanList[];bds: UserList[];bds_copy: UserList[];circles:CircleList[];dentalSpocRole=[];
  search:string;bd:string;circle:string;start_date:string='';end_date:string='';payment_status:string;paymentstart_date:string='';paymentend_date:string='';scan_status:string;visit_type:string;appointment_type:string;
  click_to_call_loading:boolean=false;response_call_id='';progression_msg='';end_to_call_btn_disable=false; callDetails=[];mdspok='';dental_mdspok='';md_source:number=34;mdSpokData=[];mdSpokData_copy=[];submitted:boolean=false;updatedLeadsStatus:string;notUpdatedLeadsStatus:string;dental_mdSpokData=[];dental_mdSpokData_copy=[];spocfollowupstart_date = '';
  spocfollowupend_date = ''; allSpocStatus = []; allSpocStatus_copy = [];dental_spoc_status='';scanProUser =[];scanProUser_copy=[];scan_pro_id:string;isCMAccess:string;
  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('ownerSearch') ownerSearchElement: ElementRef;
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

  @ViewChild('paymentdateRangeStart', {static: false}) paymentdateRangeStart: ElementRef;
  @ViewChild('paymentdateRangeEnd', {static: false}) paymentdateRangeEnd: ElementRef;

  @ViewChild('spocFollowupdateRangeStart', {static: false}) spocFollowupdateRangeStart: ElementRef;
  @ViewChild('spocFollowupdateRangeEnd', {static: false}) spocFollowupdateRangeEnd: ElementRef;

  @ViewChild('csvScanbookBulkAssignedToSpok', {static: false}) csvScanbookBulkAssignedToSpok: ElementRef;


  constructor(private leadapi:LeadsService,private sharedapi:SharedService,private dialog:MatDialog,private activatedRoute: ActivatedRoute,private dentalapi:DentalService,private router: Router) {
    
        
  }

  sharePaymentLink(lead_id,scan_id,type){
    //console.log(lead_id)
    const dialogRef = this.dialog.open(ScanPaymentModalComponent, {
        width: '45%',
        height: '50%',
        data:{lead_id:lead_id,scan_id:scan_id,type:type}
    });
    dialogRef.afterClosed().subscribe(result => {
        console.log(result);
    });
}

  ngOnInit(): void 
  {
    this.sharedapi.getRole();this.getbds();this.getcircle();this.getScanProUser();
    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');
    this.sc3Url= localStorage.getItem('s3url');
    this.isCMAccess = localStorage.getItem('CMAccess');

    if(this.myrole=='1'){
    this.pageSizeOptions = [10,25,50,100,500];
    }

    this.getMdSpok(this.md_source);
    if(this.myrole=='1' || (this.myrole=='3' && this.userId == '411') || this.userId == '431' || this.userId == '125' || this.userId == '548' || this.myrole=='21'){
        this.get_Dental_Spoc_Role();
        this.getDentalSpokRemarkStatus();
    }
  }

  ngAfterViewInit() {
    this.loadScanBooks(0,this.perpage);
  }

    async getScanProUser()
    {
        await this.dentalapi.getscanprouser().subscribe((data:UserResponse) => {
            if(data.status)
            {
                this.scanProUser = data.data;
                this.scanProUser_copy = this.scanProUser;
            }else{
                this.scanProUser = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

  setSearchValue(type){
    if(type=='lead_owner'){
      this.ownerSearchElement.nativeElement.focus();
      this.ownerSearchElement.nativeElement.value = '';
      this.bds= this.bds_copy;
    } else if(type=='mdspok'){
        $("#mdspokSearch").val('');
        $("#mdspokSearch").focus();
        this.mdSpokData= this.mdSpokData_copy;
    } else if(type=='dental_mdspok'){
        $("#dental_mdspokSearch").val('');
        $("#dental_mdspokSearch").focus();
        this.dentalSpocRole= this.dental_mdSpokData_copy;
    }  else if(type=='dental_spoc_status'){
        $("#allStatusSearch").val('');
        $("#allStatusSearch").focus();
        this.allSpocStatus= this.allSpocStatus_copy;
    } else if(type=='scan_pro_id'){
        $("#scan_pro_idSearch").val('');
        $("#scan_pro_idSearch").focus();
        this.scanProUser= this.scanProUser_copy;
    }
  }

    searchOnSelect(searchtText: string, type){
        if(type == 'lead_owner'){
        this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else if(type == 'mdspok'){
            this.mdSpokData = this.sharedapi.searchData(searchtText, this.mdSpokData_copy, "name");
        }else if(type == 'dental_mdspok'){
            this.dentalSpocRole = this.sharedapi.searchData(searchtText, this.dental_mdSpokData_copy, "name");
        }else if(type == 'dental_spoc_status'){
            this.dentalSpocRole = this.sharedapi.searchData(searchtText, this.allSpocStatus_copy, "name");
        }else if(type == 'scan_pro_id'){
            this.scanProUser = this.sharedapi.searchData(searchtText, this.scanProUser_copy, "name");
        }
    }

    async getMdSpok(md_source) {
        await this.leadapi.getMdSpokUsers(this.md_source).subscribe((response: any) => {
            console.log(response);
          if (response.status) {
            this.mdSpokData = response.data;
            this.mdSpokData_copy = this.mdSpokData;
          } else {
            this.mdSpokData = [];
          }
        }, error => {
          this.sharedapi.checkError(error);
        });
    
      }

  dateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.start_date = date1.value;
            this.end_date = date2.value;
            /* this.loadScanBooks(0,this.perpage); */
        }
    }

    clearDate()
    {
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
        /* this.loadScanBooks(0,this.perpage); */
    }

    paymentdateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.paymentstart_date = date1.value;
            this.paymentend_date = date2.value;
            /* this.loadScanBooks(0,this.perpage); */
        }
    }

    spocFOllowUpdateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.spocfollowupstart_date = date1.value;
            this.spocfollowupend_date = date2.value;
        }
    }

    paymentclearDate()
    {
        this.paymentdateRangeStart.nativeElement.value = "";
        this.paymentdateRangeEnd.nativeElement.value = "";
        this.paymentstart_date = '';
        this.paymentend_date = '';
        /* this.loadScanBooks(0,this.perpage); */
    }

    spocfollowupclearDate()
    {
        this.spocFollowupdateRangeStart.nativeElement.value = "";
        this.spocFollowupdateRangeEnd.nativeElement.value = "";
        this.spocfollowupstart_date = '';
        this.spocfollowupend_date = '';
        /* this.loadScanBooks(0,this.perpage); */
    }

    resetFilters()
    {
        this.search = ''; this.circle = ''; this.payment_status = ''; this.scan_status = ''; this.mdspok = ''; this.dental_spoc_status = ''; this.dental_mdspok = '';this.scan_pro_id = '';this.visit_type= ''; this.appointment_type = '';
        this.clearDate();
        this.paymentclearDate();
        if(this.myrole=='1' || (this.myrole=='3' && this.userId == '411') || this.userId == '431' || this.userId == '125' || this.myrole=='21'){
            this.spocfollowupclearDate();
        }
        this.loadScanBooks(0,25);
    }


  async loadScanBooks(pageIndex,perpage)
  {
      this.paginator.pageIndex = pageIndex; 
      this.paginatorBottom.pageIndex = pageIndex;
      this.pageIndex = pageIndex;
      let qString = 'search='+this.search+'&bd='+this.bd+'&circle='+this.circle+'&date_range='+this.start_date+'-'+this.end_date+'&payment_status='+this.payment_status+'&paymentdate_range='+this.paymentstart_date+'-'+this.paymentend_date+'&scan_status='+this.scan_status+'&mdspok='+this.mdspok+'&dental_mdspok='+this.dental_mdspok+'&spoc_followup_date_range='+this.spocfollowupstart_date+'-'+this.spocfollowupend_date+'&dental_spoc_status='+this.dental_spoc_status+'&scan_pro_id='+this.scan_pro_id+'&visit_type='+this.visit_type+'&appointment_type='+this.appointment_type;
      this.loading = true;this.loaded = false;
      this.scanList = [];
      await this.dentalapi.loadScanBooks(this.paginator.pageIndex,perpage,qString).subscribe((data:ScanBookListResponse) => {
          this.length = data.totaldata;
          this.loading = false;
          this.loaded = true;
          if(data.status)
          {
              this.scanList = data.data;
          }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadScanBooks(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadScanBooks(event.pageIndex,event.pageSize);
    }

    async getbds()
    {
        this.leadapi.getbds().subscribe((data:UserResponse) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy= this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:CircleResponse) => {
            if(data.status)
            {
                this.circles = data.data;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    openScanPage(scandata,type){
        if(type==1){
            var myDate = new Date(scandata.appointment_datetime*1000);
            var futureDate = new Date(myDate.getTime() + 15*60000);
            var newTimeStamp = Math.floor((new Date(futureDate)).getTime() / 1000);
            var currentTimeStamp = Math.floor((new Date()).getTime() / 1000);
            
            if(this.myrole == '2'){ //Added as per discussion with Manpreet this condition is only for BD's//
                if(newTimeStamp <= currentTimeStamp){
                    this.router.navigateByUrl('/update-scan/'+scandata.lead_id+'/'+scandata.id);
                }else{
                    alert('Please visit after 15 minutes of scan booking');
                }
            } else {
                this.router.navigateByUrl('/update-scan/'+scandata.lead_id+'/'+scandata.id);
            }
            

        }else{
            this.router.navigateByUrl('/re-scan/'+scandata.lead_id+'/'+scandata.id);
        }
       
    }

    updateScanStatus(scanId,status){
        this.dentalapi.updateScanStatus(scanId,status)
        .subscribe((data:any) => {
        if(data.status)
        {
            this.sharedapi.presentToast(data.msg);
            this.loadScanBooks(0,this.perpage);
        }
        else
        {
            this.sharedapi.presentToast(data.msg);
        }
        }, error => 
        {
            
            this.sharedapi.checkError(error);
        });
    }

    calculate_gst(total_amt,paymentDate){
        //var total_amt = this.ScanUpdateForm.get('billed_amt').value;
        if(total_amt){
            var november = 1667241000;
            var gst ;
            if(paymentDate > november){
                gst = 1.05;
            }
            else{
                gst = 1.12;
            }
          var gst_billed_amount = (total_amt/gst).toFixed(2);
          var gst_amount = (total_amt.toFixed(2) - Number(gst_billed_amount));
          return gst_amount.toFixed(2);
        }else{
          return 0;
        }
      }

    forExcelcalculate_gst(total_amt,paymentDate){
    //var total_amt = this.ScanUpdateForm.get('billed_amt').value;
    if(total_amt){
        var november = 1667241000;
        var gst ;
        if(paymentDate > november){
            gst = 1.05;
        }
        else{
            gst = 1.12;
        }
        var gst_billed_amount = (total_amt/gst);
        var gst_amount = (total_amt - Number(gst_billed_amount));
        return gst_amount.toFixed(2);
    }else{
        return 0;
    }
    }  

    exportScanList()
    {
        if(this.scanList.length>0)
        {
            let data = [];
            let titles = [
                'Lead Source',
                'Appointment Id',
                'Glamyo Partner Id',
                'Glamyo Appointment Id',
                'Patient Name',
                'Patient Age',
                'Patient Email',
                'Gender',
                'Circle',
                'Lead Owner',
                'Lead Owner Email',
                'Treatment',
                'Machine',
                'Scan Pro',
                'Appointment Type',
                'Appointment Date',
                'Timeslot',
                'Lead Date',
                'Payment Date',
                'Visit Type',
                'Visit Address',
                'Hospital Name',
                'Package Price',
                'Total Amount',
                'Received Amount',
                'GST Amount',
                'Net Amount',
                'Plan Sent At',
                'Plan Approved',
                'Plan Approval Date',
                'Scan Last Payment Mode',
                'Scan Last Payment Amount',
                'Lead Payment Mode',
                'Status',
                'Scan Status',
                'No Scan Reason',
                'RCA',
                'Sub RCA',
                'Campaign Name',
                'Keywords',
                'AD Group Id',
                'Match Type',
                'Form Lead Source',
                'MD Spoc',
                'Assigned to Dental Spoc',
                'Dental Spoc Remark Status',
                'Dental Spoc Remark Sub Status',
                'Spoc Followup Date',
                'Scan Booked Date',
            ];

            if(this.myrole=='1' || this.userId == '125' || this.userId == '431' || this.userId == '548' || this.userId == '172' || this.userId == '63' || this.userId == '525' || this.userId == '346' || this.userId == '576' || this.userId == '490' || this.userId == '619' || this.userId == '388' || this.userId == '727')
            {
                titles.push('Patient Mobile');
            }

            data.push(titles);
            for(let key in this.scanList)
            {

                // this.scanList[key].lead_name
                let visitType = 'Home';
                if(this.scanList[key].visit_type==2){
                    visitType = 'Clinic';
                }else if(this.scanList[key].visit_type==3){
                    visitType = 'Glamyo';
                }

                let payment_date = '';
                if(this.scanList[key].payment_datetime) 
                {
                    payment_date = formatDate(this.scanList[key].payment_datetime*1000, 'dd-MM-yyyy', 'en-US');
                }
                else
                {
                    payment_date = '';
                }

                let sc_text = '';
                if(this.scanList[key].scan_status==1){
                    sc_text = 'Yes';
                } else {
                    sc_text = 'No';
                }

                let rca_text = '';
                if(this.scanList[key].scan_status==2) {
                    if(this.scanList[key].rca==1){
                        rca_text = 'Budget Problem';
                    } else if(this.scanList[key].rca==2){
                        rca_text = 'Want Reschedule';
                    } else if(this.scanList[key].rca==3){
                        rca_text = 'Cancel Appointment';
                    } else if(this.scanList[key].rca==4){
                        rca_text = 'Scanner Movement Delay';
                    } else if(this.scanList[key].rca==5){
                        rca_text = 'Not Answer';
                    }
                }

                let sub_rca_text = '';
                if(this.scanList[key].scan_status==2) {
                    if(this.scanList[key].sub_rca==1){
                        sub_rca_text = 'Other';
                    } else if(this.scanList[key].sub_rca==2){
                        sub_rca_text = 'Physically not well';
                    } else if(this.scanList[key].sub_rca==3){
                        sub_rca_text = 'Customer Not available';
                    } else if(this.scanList[key].sub_rca==4){
                        sub_rca_text = 'Scanner Issue';
                    } else if(this.scanList[key].sub_rca==5){
                        sub_rca_text = 'Customer Cancel';
                    } else if(this.scanList[key].sub_rca==6){
                        sub_rca_text = 'Customer Refused';
                    } else if(this.scanList[key].sub_rca==7){
                        sub_rca_text = 'Cancel by Counsellor';
                    } else if(this.scanList[key].sub_rca==8){
                        sub_rca_text = 'Cancel By Pro';
                    } else if(this.scanList[key].sub_rca==9){
                        sub_rca_text = 'Denied Pro';
                    } else if(this.scanList[key].sub_rca==10){
                        sub_rca_text = 'Travel Distance High';
                    } else if(this.scanList[key].sub_rca==11){
                        sub_rca_text = 'Office Boy Not Reached On Time';
                    } else if(this.scanList[key].sub_rca==12){
                        sub_rca_text = 'Last appointment Was Delay';
                    } else if(this.scanList[key].sub_rca==13){
                        sub_rca_text = 'Booked by Underage';
                    } else if(this.scanList[key].sub_rca==14){
                        sub_rca_text = 'Wrong Booking';
                    } else if(this.scanList[key].sub_rca==15){
                        sub_rca_text = 'Fake Booking';
                    }
                }

                let last_payment_mode = '';
                if(this.scanList[key].payment_status==1) {
                    if(this.scanList[key].last_payment_mode==1){
                        last_payment_mode = 'Cash';
                    } else if(this.scanList[key].last_payment_mode==2){
                        last_payment_mode = 'Cheque';
                    } else if(this.scanList[key].last_payment_mode==3){
                        last_payment_mode = 'Razor Pay';
                    } else if(this.scanList[key].last_payment_mode==4){
                        last_payment_mode = 'EMI';
                    } else if(this.scanList[key].last_payment_mode==5){
                        last_payment_mode = 'Net Banking';
                    } else if(this.scanList[key].last_payment_mode==6){
                        last_payment_mode = 'Insurance';
                    }
                }

                let spoc_remark_status = ''; 
                if(this.scanList[key].spok_status_id==1){
                    spoc_remark_status = 'Payment Received';
                } else if(this.scanList[key].spok_status_id==2){
                    spoc_remark_status = 'DNP';
                } else if(this.scanList[key].spok_status_id==3){
                    spoc_remark_status = 'Treatment Hold';
                } else if(this.scanList[key].spok_status_id==4){
                    spoc_remark_status = 'Forfeit';
                } else if(this.scanList[key].spok_status_id==5){
                    spoc_remark_status = 'Followup';
                } else if(this.scanList[key].spok_status_id==6){
                    spoc_remark_status = 'Plan Pending';
                } else if(this.scanList[key].spok_status_id==7){
                    spoc_remark_status = 'Documents Pending';
                }

                let spoc_remark_sub_status = ''; 
                if(this.scanList[key].spoc_sub_status_id==8){ 
                    spoc_remark_sub_status = "Part Payment Received"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==9){ 
                    spoc_remark_sub_status = "Full Payment"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==10){ 
                    spoc_remark_sub_status = "RNR"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==11){ 
                    spoc_remark_sub_status = "Switched Off"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==12){ 
                    spoc_remark_sub_status = "Not Contactable after many attempts"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==13){ 
                    spoc_remark_sub_status = "Fund Issue"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==14){ 
                    spoc_remark_sub_status = "Rescan"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==15){ 
                    spoc_remark_sub_status = "Replan Pending"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==16){ 
                    spoc_remark_sub_status = "Out of City"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==17){ 
                    spoc_remark_sub_status = "Other (Treatment Hold)"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==18){ 
                    spoc_remark_sub_status = "EMI Rejected Low Cibil"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==19){ 
                    spoc_remark_sub_status = "Dont want extraction"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==20){ 
                    spoc_remark_sub_status = "Delay in Follow Up"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==21){ 
                    spoc_remark_sub_status = "Not Happy With Plan"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==22){ 
                    spoc_remark_sub_status = "Wrong Information Shared by Pro"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==23){ 
                    spoc_remark_sub_status = "Other (Forfeit)"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==24){ 
                    spoc_remark_sub_status = "Rescan (Followup)"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==25){ 
                    spoc_remark_sub_status = "Replan Required"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==26){ 
                    spoc_remark_sub_status = "Part Payment Approval Pending"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==27){ 
                    spoc_remark_sub_status = "Other (Followup)"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==28){ 
                    spoc_remark_sub_status = "Lab Side Pending"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==29){ 
                    spoc_remark_sub_status = "Rescan Files Pending"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==30){ 
                    spoc_remark_sub_status = "Delay by Ops team"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==31){ 
                    spoc_remark_sub_status = "Not shared by city team"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==32){ 
                    spoc_remark_sub_status = "Incorrect Docs shared"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==33){ 
                    spoc_remark_sub_status = "Complete Documents Pending"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==34){ 
                    spoc_remark_sub_status = "Bank Statement Pending"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==35){ 
                    spoc_remark_sub_status = "Co-Applicant Documents pending"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==36){ 
                    spoc_remark_sub_status = "Documents Pending"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==37){ 
                    spoc_remark_sub_status = "Payment link shared waiting for confirmation"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==38){ 
                    spoc_remark_sub_status = "Clinic visit required"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==39){ 
                    spoc_remark_sub_status = "Trust issue / Need a F2F visit"; 
                }
                else if(this.scanList[key].spoc_sub_status_id==40){ 
                    spoc_remark_sub_status = "Cash / cheque doorstep collection"; 
                }

                let appointment_type_str = '';
                if(this.scanList[key].appointment_type==1){ 
                    appointment_type_str = "New Scan"; 
                } else if(this.scanList[key].appointment_type==2){ 
                    appointment_type_str = "Re-Scan"; 
                } else if(this.scanList[key].appointment_type==3){ 
                    appointment_type_str = "Trust Align"; 
                }

                let share_with_patient_on_date = '';
                if(this.scanList[key].share_with_patient_on) 
                {
                    share_with_patient_on_date = formatDate(this.scanList[key].share_with_patient_on*1000, 'dd-MM-yyyy hh:mm a', 'en-US');
                }

                let glamyoPatientId = 'GHDEN'+this.scanList[key].id;
                let exdata = [
                    this.scanList[key].source_name,
                    this.scanList[key].appointment_id,
                    this.scanList[key].glamyo_patient_id,
                    glamyoPatientId,
                    this.scanList[key].lead_name,
                    this.scanList[key].patient_age,
                    this.scanList[key].email,
                    this.scanList[key].gender,
                    this.scanList[key].circle_name,
                    this.scanList[key].bd_name,
                    this.scanList[key].bd_email,
                    this.scanList[key].treatment_name,
                    this.scanList[key].machinename,
                    this.scanList[key].scan_pro_user,
                    appointment_type_str,
                    formatDate(this.scanList[key].appointment_datetime*1000, 'dd-MM-yyyy', 'en-US'),
                    this.scanList[key].time_slots,
                    formatDate(this.scanList[key].lead_date*1000, 'dd-MM-yyyy', 'en-US'),
                    payment_date,
                    visitType,
                    this.scanList[key].address,
                    this.scanList[key].hospitalname,
                    this.scanList[key].package_price,
                    this.scanList[key].totalAmt,
                    this.scanList[key].received_amt,
                    this.forExcelcalculate_gst(this.scanList[key].totalAmt,this.scanList[key].payment_datetime),
                    (this.scanList[key].totalAmt - Number(this.forExcelcalculate_gst(this.scanList[key].totalAmt,this.scanList[key].payment_datetime))),
                    share_with_patient_on_date,
                    this.scanList[key].approval_received == 1 ? 'Yes' : 'No',
                    this.scanList[key].approval_received_date ? formatDate(this.scanList[key].approval_received_date*1000, 'dd-MM-yyyy', 'en-US'): '',
                    last_payment_mode,
                    this.scanList[key].last_received_amount,
                    this.scanList[key].payment_mode,
                    this.sharedapi.getStatus(this.scanList[key].status),
                    sc_text,
                    this.scanList[key].scan_status_comments,
                    rca_text,sub_rca_text,
                    this.scanList[key].campaign_name,
                    this.scanList[key].keywords,
                    this.scanList[key].utm_agid,
                    this.scanList[key].matchtype,
                    this.scanList[key].zoho_lead_source,
                    this.scanList[key].mdspok_user,
                    this.scanList[key].dental_spock_user,
                    spoc_remark_status,
                    spoc_remark_sub_status,
                    this.scanList[key].spoc_followup_date ? formatDate(this.scanList[key].spoc_followup_date*1000, 'dd-MM-yyyy hh:mm aa', 'en-US') : "",
                    this.scanList[key].created_at ? formatDate(this.scanList[key].created_at*1000, 'dd-MM-yyyy', 'en-US') : ""
                ]
                if(this.myrole=='1' || this.userId == '125' || this.userId == '431' || this.userId == '548' || this.userId == '172' || this.userId == '63' || this.userId == '525' || this.userId == '346' || this.userId == '576' || this.userId == '490' || this.userId == '619' || this.userId == '388' || this.userId == '727')
                {
                    exdata.push(this.scanList[key].mobile);
                }
                
                data.push(exdata)
            }
            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'scanbook_list_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

    click_to_call_function(lead_id)
    {
        this.click_to_call_loading = true;
        let lead_id_arr = {'lead_id': lead_id};
        this.leadapi.OpdIpdClickTOCall(lead_id_arr).subscribe((data:any) => {
            this.click_to_call_loading = false;
            console.log(data);
            if(data.status){
                this.response_call_id = data.call_id;
                $("#click_to_call_progress").modal("show");
            } else {
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    endClicktoCall()
    {
        this.progression_msg = "";
        this.end_to_call_btn_disable = true;
        if(this.response_call_id)
        {
            let lead_id_arr = {'response_call_id': this.response_call_id};
            this.leadapi.endClicktoCall(lead_id_arr).subscribe((data:any) => {
                this.end_to_call_btn_disable = false;
                $('#click_to_call_progress').modal('hide');
            }, error => {
                this.sharedapi.checkError(error);
            });
        } else {
            this.sharedapi.checkError("Please reload the page. Something went to wrong.");
        }
        
    }
    async call_details(lead_id)
    {
        await this.leadapi.getIpdOpdCallDetails(lead_id).subscribe((data: any) => {
            if (data.status) {
                $("#scan_book_call_details").modal("show");
              this.callDetails = data.data;
            } else {
              this.callDetails = [];
            }
          }, error => {
            this.sharedapi.checkError(error);
          });
    }

    closeCallDetailsModal(){
        $('#scan_book_call_details').modal('hide');
    }

    copyMessage(text: string) {
        this.sharedapi.presentToast('Link copied to clipboard.');
        navigator.clipboard.writeText(text).then().catch(e => console.log(e));
      }
      
      async get_Dental_Spoc_Role()
      {
          await this.dentalapi.getDentalSpocRoleData().subscribe((data:CircleResponse) => {
              if(data.status)
              {
                  this.dentalSpocRole = data.data;
                  this.dental_mdSpokData_copy = this.dentalSpocRole;
              }else{
                  this.dentalSpocRole = [];
              }
          }, error => {
              this.sharedapi.checkError(error);
          });
      }

      updateAssigneDentalSpok(userId: number, scanbook_id: number)
      {
          this.dentalapi.assigneDentalSpok(userId, scanbook_id).subscribe((data:any) => {
              if(data.status) {
                  this.sharedapi.presentToast(data.msg);
                  this.loadScanBooks(this.pageIndex,this.perpage);
              }
          }, error => {
              this.sharedapi.checkError(error);
          });
      }

    spokRemarks(scanId){
        const dialogRef = this.dialog.open(SpokRemarksComponent, {
            width: '45%',
            height: '50%',
            data:{scanId:scanId}
        });
        dialogRef.afterClosed().subscribe(result => {
            this.loadScanBooks(0,25);
        });
    }

    accountsRemarks(scanId, leadId){
        const dialogRef = this.dialog.open(AccountsRemarksComponent, {
            width: '90%',
            height: '90%',
            data:{scanId:scanId, leadId:leadId}
        });
        dialogRef.afterClosed().subscribe(result => {
            this.loadScanBooks(0,25);
        });
    }

    scanproAssignment(scanId){
        const dialogRef = this.dialog.open(ScanProAssignmentComponent, {
            width: '45%',
            height: '50%',
            data:{scanId:scanId}
        });
        dialogRef.afterClosed().subscribe(result => {
            this.loadScanBooks(0,25);
        });
    }

    showAssignedtoSpokModal()
    {
        $('#scanbookAssignedToDentalSpok').modal();
    }

    hideAssignedToDentalModal()
    {
        $('#scanbookAssignedToDentalSpok').modal('hide');
    }

    async selectFileUpdateLeadStatus(event)
    {
        this.submitted = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.leadapi.uploadcsvOfScanbookAssignedtoSpokUpdate(formData).subscribe((data:any) => {
            this.submitted = false;
            this.csvScanbookBulkAssignedToSpok.nativeElement.value = "";
            if(data.status)
            {
                this.updatedLeadsStatus = data.updatedLeadId;
                this.notUpdatedLeadsStatus = data.notUpdatedLeadId;
            }
            else
            {
                this.sharedapi.presentToast(data.msg);

            }
        }, error =>
        {
            this.sharedapi.checkError(error);
        });
    }

    async getDentalSpokRemarkStatus() {
        await this.dentalapi.getDentalSpokRemarkStatus(0).subscribe((data: any) => {
          if (data.status) {
            this.allSpocStatus = data.data;
            this.allSpocStatus_copy = this.allSpocStatus;
          } else {
            this.allSpocStatus = [];
          }
        }, error => {
          this.sharedapi.checkError(error);
        });
    }

    scanBookCaseHistory(scanId){
        const dialogRef = this.dialog.open(ScanBookCaseHistoryComponent, {
            width: '100%',height: '95%',
            data:{scanId:scanId}
        });
        
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }
       
}